// core
import React from "react";

// components
import LModal from "../../../../../common/components/Modals/LModal/LModal";
import ModalHeader from "../../../../../common/components/Modals/ModalHeader/ModalHeader";

interface ICignaTraumaTwoYearsFreeSpecialOfferModal {
    isOpen: boolean;
    onClose: () => void;
}

const CignaTraumaTwoYearsFreeSpecialOfferModal: React.FC<ICignaTraumaTwoYearsFreeSpecialOfferModal> = (
    props
) => {
    const { isOpen, onClose } = props;

    return (
        <React.Fragment>
            <LModal
                Header={() => (
                    <ModalHeader
                        onClose={onClose}
                        title="Free Trauma cover for 2 years"
                    />
                )}
                calcHeightMode="auto"
                width="wide"
                isOpen={isOpen}
                onClose={onClose}>
                {() => (
                    <React.Fragment>
                        <p>
                            There&apos;s no cover like free cover. Until 31 March 2022 if
                            you take out or top up Cigna Assurance Extra Life Insurance
                            Cover by $100,000 through Life Direct, you could get up to
                            $30,000 of free critical illness cover for two years.
                        </p>
                        <h3 className="heading-modal-section text-primary">
                            Terms and Conditions
                        </h3>
                        <ol>
                            <li>
                                <p>
                                    Apply for $100,000 or more of Life Cover on a new
                                    eligible Cigna Assurance Extra policy or for an
                                    underwritten increase of $100,000 or more in Life
                                    Cover on an existing eligible Cigna Assurance Extra
                                    policy, through a Cigna-authorised independent
                                    financial adviser, between 1 February 2022 and 31
                                    March 2022 (“Campaign Dates”), and have the policy or
                                    increased cover issued by 30 April 2022 (“EndDate”),
                                    and receive two years&apos; free Assurance Extra
                                    Trauma Cover on us.
                                </p>
                            </li>
                            <li>
                                <p>
                                    The free Trauma Cover sum insured will the lesser of:
                                </p>
                                <ul className="list-solid-disc">
                                    <li>
                                        10% of the amount of the new or additional Life
                                        Cover; and
                                    </li>
                                    <li>$30,000.</li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    Cigna Assurance Extra policies are eligible for the
                                    free Trauma Cover if:
                                </p>
                                <ul className="list-solid-disc">
                                    <li>
                                        the policy was first issued on or after 1 May
                                        2008;
                                    </li>
                                    <li>
                                        the life assured is under the age of 56 at the
                                        time of applying for the new or increased Life
                                        Cover;
                                    </li>
                                    <li>
                                        the new or increased Life Cover is issued at
                                        standard premium rates or with a premium loading
                                        not greater than 150% or $2 per mille; and
                                    </li>
                                    <li>
                                        in the case of a Life Cover increase on an
                                        existing policy, the increase is subject to full
                                        underwriting. Increases subject to no or limited
                                        underwriting (including life events and guaranteed
                                        insurability increases) are excluded.
                                    </li>
                                </ul>
                            </li>
                            <li>
                                <p>
                                    The free Trauma Cover will be issued in respect of the
                                    life assured applying for the new or increased Life
                                    Cover. The maximum free Trauma Cover per life assured
                                    (across all Cigna policies) is $30,000.
                                </p>
                            </li>
                            <li>
                                <p>The free Trauma Cover:</p>
                                <ul className="list-solid-disc">
                                    <li>
                                        will not be adjusted for inflation and will not
                                        include any optional benefits (for example, TPD or
                                        buy-back options)
                                    </li>
                                    <li>
                                        will be issued on the same terms (i.e. with the
                                        same loadings and exclusions) as the new or
                                        increased Life Cover.
                                    </li>
                                </ul>
                                <p>
                                    The features and terms of the free Trauma Cover may
                                    therefore be different to any other Trauma Cover the
                                    life assured has on the policy.
                                </p>
                            </li>
                            <li>
                                <p>
                                    The free Trauma Cover will be issued with effect from
                                    the date the new or increased Life Cover is issued
                                    and, unless expired or cancelled earlier, will be
                                    provided free of charge for a period of 2 years from
                                    that date. Following the end of that 2 year period the
                                    free Trauma Cover will automatically expire unless the
                                    policy owner(s) choose to continue the cover on the
                                    same terms and to pay any associated premiums.
                                </p>
                            </li>
                            <li>
                                <p>
                                    The free Trauma Cover will expire, and will not be
                                    able to be continued, if the policy or the life
                                    assured&apos;s Life Cover lapses, expires or is
                                    cancelled before the end of the 2 year period. Cigna
                                    reserves the right to expire or reduce the sum insured
                                    for the free Trauma Cover, and/or to not offer
                                    continuation of the Trauma Cover, if the Life Cover in
                                    respect of which it is issued is reduced before the
                                    end of the 2 year period.
                                </p>
                            </li>
                            <li>
                                <p>
                                    This offer is only available to customers applying
                                    through independent distributors authorised by Cigna
                                    to distribute and advise on eligible Cigna policies.
                                    It is not available to customers applying directly
                                    through Cigna, through Cigna&apos;s partner
                                    relationships or through any other distribution
                                    channels.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Reinstatements of policies or covers previously
                                    cancelled or lapsed, and replacements of existing or
                                    similar policies or covers are not included in this
                                    offer. Applications first submitted before 1 February
                                    2022 but resubmitted during the Campaign Dates are
                                    also excluded.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Applications are subject to Cigna&apos;s usual
                                    acceptance and underwriting criteria. Cigna accepts no
                                    responsibility for any delay in the underwriting or
                                    assessment of any application. Applications made
                                    during the Campaign Dates but where the policy or
                                    increase is not issued until after the End Date are
                                    not eligible for this offer.
                                </p>
                            </li>
                            <li>
                                <p>
                                    Cigna reserves the right to change the terms and
                                    conditions of this offer, to end it early or to extend
                                    it at any time.
                                </p>
                            </li>
                            <li>
                                <p>
                                    This offer is made by Cigna Life Insurance New Zealand
                                    Limited, of Level 24, Majestic Centre, 100 Willis
                                    Street, Wellington 6142.
                                </p>
                            </li>
                        </ol>
                    </React.Fragment>
                )}
            </LModal>
        </React.Fragment>
    );
};

export default CignaTraumaTwoYearsFreeSpecialOfferModal;
